export function getRouteKey(route) {
    const metaKey = route.meta.key;
    if (typeof metaKey === 'string') {
        return metaKey;
    }
    if (typeof metaKey === 'function') {
        return metaKey(route);
    }
    return undefined;
}
//# sourceMappingURL=getRouteKey.js.map